<svelte:options accessors/>
<script lang="ts">
    import PagoAppSummary from "./PagoAppSummary.svelte";
    import PagoAppBuscar from "./PagoAppBuscar.svelte";
    import PagoAppCard from "./card/PagoAppCard.svelte";
    import type {ICuota, IPago, IPagoCard, IPagoGroup, IReglas} from "../../interfaces";
    import PagosFormasDisponibles from "./PagosFormasDisponibles.svelte";
    import PagoAppFilters from "./PagoAppFilters.svelte";
    import {createEventDispatcher, onMount} from "svelte";
    import {httpRequest} from "../../utils";
    import {AppFilters} from "../../models/app-filters";
    import Dialog, {Title, Content, Actions} from '@smui/dialog';
    import NauiButton from "../../naui/atoms/NauiButton.svelte";

    let dispatch = createEventDispatcher();

    export let data: Array<IPagoGroup>;
    export let cart: Array<any>;

    let filtered: Array<string> = null;

    export let openSearch = false;

    export let resumenUrl;
    export let reciboUrl;

    let openFormas = false;

    let reglas: IReglas = {
        regla_1: null,
        regla_2: null,
        regla_3: null,
        regla_4: null,
        regla_5: null,
        regla_6: null,
        vencido: false,
        regla_endosos: false,
        regla_tomador: null,
        regla_preliquidacion: false,
    };


    let endosos: Array<IPagoCard> = [];
    let cuotas: Array<ICuota> = [];

    let polizaGroups: { [key: string]: Array<IPago> } = {};
    let filters: AppFilters;

    let open = false
    let dialogMessage = ''

    let cuotasOrden: any = {}


    let total = 0;

    export let rol = '';


    $: getTotal(data)


    function getTotal(data) {
        total = 0
        for (const tipo of data) {

            for (const payment of tipo.payments) {
                total = total + payment.cuotas.cuotas.filter((c) => c.selected).reduce((total2, s) => total2 + s.valor, 0)
            }

        }
    }

    onMount(() => {
        const optsHashes = {};
        for (const item of data) {
            for (const payment of item.payments) {
                payment.cuotas.details = payment.detalles;
                cuotasOrden[payment.id] = false
                payment.cuotas.id = payment.id
                payment.cuotas.parent = item;
                if (!polizaGroups.hasOwnProperty(payment.cuotas.productId)) {
                    polizaGroups[payment.cuotas.productId] = [];
                }
                polizaGroups[payment.cuotas.productId].push(payment);

                for (const cuota of payment.cuotas.cuotas) {
                    cuota.parent = payment.cuotas;
                }
                optsHashes[payment.cuotas.category] = '';
            }
        }

        if (cart.length > 0) {
            for (const endoso of cart) {
                const dataEndoso = polizaGroups[endoso.productId].find(p => p.cuotas.endoso === endoso.endoso);
                for (const cuota of endoso.cuotas) {
                    const cuotaEndoso = dataEndoso.cuotas.cuotas.find(c => c.recibo === cuota.recibo);
                    if (cuotaEndoso) {
                        cuotaEndoso.selected = cuota.selected;
                        if (cuotaEndoso.selected) {
                            cuotas = [...cuotas, cuotaEndoso];
                        }
                    }
                }
            }
        }
        checkEndosoStatus();
        filtered = null;
        filters = new AppFilters(Object.keys(optsHashes));

    });

    function updatedChecks(eventData: { data: any, type: string, parent?: IPagoCard }, clearRules = false) {


        if (clearRules) {
            reglas.regla_1 = null;
            reglas.regla_4 = null;
            reglas.regla_5 = null;
            reglas.regla_6 = null;
            reglas.vencido = false;
            reglas.regla_endosos = false;
            reglas.regla_tomador = null;
            reglas.regla_preliquidacion=false;
        }
        let flagType = true


        if (eventData.type === 'cuota') {

            flagType = eventData.data.parent.parent.type !== 'pagare'
        } else if (eventData.type === 'endoso') {

            flagType = eventData.data.parent.type !== 'pagare'
        }


        if (flagType && validateSortSelected(eventData)) {
            reglas.regla_endosos = true;
            return
        }

        if (validateTomador(eventData)) {
            eventData.data.selected = !eventData.data.selected;
            data = data;
            reglas.regla_tomador = true;
            return
        }

        if (validatePreliquidacion(eventData)) {
            eventData.data.selected = !eventData.data.selected;
            data = data;
            reglas.regla_preliquidacion=true;
            return
        }

        if (eventData.type === 'cuota') {
            const valid = validateSelectedCoutas(eventData.data, eventData.parent);
            if (valid) {
                if (eventData.data.selected) {
                    cuotas = [...cuotas, eventData.data];
                } else {
                    cuotas = cuotas.filter(c => c !== eventData.data);
                }
            } else {
                eventData.data.selected = !eventData.data.selected;
            }
        } else {
            validateSelectedEndosos(eventData.data);
        }
        checkEndosoStatus();
        data = data;
        refreshComponents();
    }

    function checkEndosoStatus() {
        for (const item of data) {
            for (const p of item.payments) {
                p.cuotas.selected = p.cuotas.cuotas.some(c => c.selected);
            }
        }
    }

    function refreshComponents() {
        for (const item of data) {
            for (const p of item.payments) {
                p.ref.refresh();
            }
        }
    }

    function validateTomador(eventData: { data: any, type: string, parent?: IPagoCard }) {
        let result = false;
        if (rol === 'INT') {
            let tomadorId = eventData.type === 'endoso' ? eventData.data.details.poliza.id_tomador : eventData.parent.details.poliza.id_tomador;
            result = data.some(item => item.payments.some(payment => payment.cuotas.cuotas.some(cuota => cuota.selected) && payment.detalles.poliza.id_tomador !== tomadorId))
        }
        return result;
    }

    function validatePreliquidacion(eventData: { data: any, type: string, parent?: IPagoCard }) {
        let result = false;
        if (eventData.data.selected) {
            let arrId = eventData.type === 'endoso' ? eventData.data.referenceList : [eventData.data.recibo]
            let pagoType = eventData.type === 'endoso' ? eventData.data.parent.type : eventData.parent.parent.type
            result = data.some(item => item.payments.some(payment => payment.cuotas.cuotas.some(cuota => cuota.selected && !arrId.includes(cuota.recibo))) && (item.type === 'PreLiquidation' || pagoType === 'PreLiquidation'));
        }
        return result;
    }

    function validateSelectedCoutas(cuota: ICuota, parent: IPagoCard) {
        const grp = polizaGroups[parent.productId];
        if (cuota.selected) {
            if (cuota.valor < 0) {
                /* Regla 4. Para que los saldos a favor con tipo SCM no se puedan seleccionar */
                if (parent.TipoDeSaldo.toUpperCase() === 'SCM' &&
                    !grp.some(g => g.cuotas.cuotas.some(c => c.selected && c.valor > 0))) {
                    reglas.regla_4 = true;
                    return false;
                }
                return true;
            } else {
                /* Regla de ordenamiento por número de cuota */
                if (parent.cuotas.some(c => +c.numero < +cuota.numero && !c.selected && c.valor > 0)) {
                    console.log('Falló ordenamiento cuotas');
                    cuotasOrden[parent.id] = true
                    return false;
                }
                cuotasOrden[parent.id] = false
                if (cuota.estado.code === 4) {
                    reglas.vencido = true;
                }

                regla1(cuota, parent, grp);
                regla5y6(cuota, parent, grp);
            }
        } else {
            if (cuota.valor < 0) {
                regla1(cuota, parent, grp);
            } else {
                regla5y6(cuota, parent, grp);
                for (const c of parent.cuotas.filter(c => +c.numero > +cuota.numero && c.selected)) {
                    c.selected = false;
                    regla5y6(c, c.parent, polizaGroups[c.parent.productId]);
                }
                for (const p of grp.filter(p => +p.cuotas.endoso > +parent.endoso)) {
                    for (const c of p.cuotas.cuotas.filter(c => c.selected)) {
                        c.selected = false;
                        regla5y6(c, c.parent, polizaGroups[c.parent.productId]);
                    }
                }
            }
        }

        return true;
    }

    function regla5y6(cuota: ICuota, parent: IPagoCard, grp: Array<IPago>) {

        if (cuota.parent.details.formaPago === 'contado' && cuota.parent.parent.type !== 'pagare') {
            return
        }

        /* Regla 5. Cuotas mismos pagarés, diferentes pólizas, misma fecha vencimiento */
        for (const pago of parent.parent.payments.filter(p => p.cuotas !== parent)) {
            for (const c of pago.cuotas.cuotas) {
                if (c.fechaLimite === cuota.fechaLimite && c.valor > 0) {
                    c.selected = cuota.selected;
                    if (c.selected) {
                        regla1(c, pago.cuotas, polizaGroups[pago.cuotas.productId])
                        reglas.regla_5 = true;
                    }
                }
            }
        }

        /* Regla 6. Cuotas diferentes pagarés, misma poliza y vencidos */
        for (const pago of grp.filter(p => p.cuotas !== parent)) {
            for (const c of pago.cuotas.cuotas) {
                if (c.estado.code === 4 && c.fechaLimite === cuota.fechaLimite && c.valor > 0) {
                    c.selected = cuota.selected;
                    if (c.selected) {
                        reglas.regla_6 = true;
                    }
                }
            }
        }
    }

    function regla1(cuota: ICuota, parent: IPagoCard, grp: Array<IPago>) {
        let groupTotal = grp.reduce((t, g) => t + +g.cuotas.cuotas.reduce((t2, c) => c.selected ? t2 + +c.valor : t2, 0), 0);

        for (const item of grp) {
            /* Regla 1. Para que se checkeen saldos negativos automáticamente */

            for (const c of item.cuotas.cuotas.filter(c => !c.selected && c.valor < 0 && !validateTomador({
                data: c, type: 'cuota', parent: c.parent
            }))) {
                if ((groupTotal + c.valor) > 0) {
                    groupTotal += c.valor;
                    c.selected = true;
                    reglas.regla_1 = c.parent.productId;
                }
            }
        }
    }

    function validateSortSelected(eventData: { data: any, type: string, parent?: IPagoCard }) {
        let validateConsecutivo;

        if (eventData.type !== 'cuota') {
            validateConsecutivo = eventData.data.parent.payments.some((payment) => (+payment.cuotas.endoso < +eventData.data.endoso) && !payment.cuotas.selected && payment.cuotas.cuotas[0].valor >= 0)
        } else {
            validateConsecutivo = eventData.parent.parent.payments.some((payment) => (+payment.cuotas.endoso < +eventData.data.parent.endoso) && !payment.cuotas.selected && payment.cuotas.cuotas[0].valor >= 0)
        }

        if (validateConsecutivo) {
            eventData.data.selected = false
            console.log('Se requiere seleccionar los endosos anteriores')
        }

        data = data;
        refreshComponents();
        return validateConsecutivo
    }

    function validateSelectedEndosos(endoso: IPagoCard) {
        for (const cuota of endoso.cuotas) {
            cuota.selected = endoso.selected;
            updatedChecks({data: cuota, type: 'cuota', parent: endoso});
        }
    }

    function applyFilters() {
        filters = filters;
        const params = filters.filterParams;

        if (!params) {
            filtered = null;
            data = data;
            return;
        }

        httpRequest({method: 'GET', data: filters.filterParams})
            .then(res => res.json())
            .then((jsonData: any) => {
                filtered = jsonData.filtered;
                data = data;
            });
    }

    function createPayment() {


        if (total <= 0) {
            return
        }

        const endososUnificados = data.reduce((lista, item) => {
            for (const payment of item.payments) {

                if (payment.cuotas.selected) {
                    lista.push(payment.cuotas)
                }
            }
            return lista;
        }, []);

        for (const endoso of endososUnificados) {
            endoso.parent = null
            for (const cuota of endoso.cuotas) {
                cuota.parent = null
            }
        }


        httpRequest({method: 'POST', data: {endosos: endososUnificados}})
            .then((res) => {
                if (res.ok) {
                    location.href = resumenUrl;
                } else {
                    // TODO Mostrar error al intentar hacer el pago.
                    alert('Error haciendo el pago');
                }
            });
    }

    function isFiltered(params: { group?: IPagoGroup, payment?: IPago }) {
        if (filtered) {
            if (params.group) {
                return params.group.payments.some(p => p.cuotas.cuotas.some(c => filtered.some(id => id === c.recibo)));
            }
            if (params.payment) {
                return params.payment.cuotas.cuotas.some(c => filtered.some(id => id === c.recibo));
            }
        }
        return true;
    }
</script>

<PagoAppFilters on:edit={()=> openSearch = true} bind:appFilters={filters} on:change={applyFilters}/>
<section class="py-15 back-gray">
    <div class="container">
        <div class="grid-3-1 gap-15 m:block m:gap-0">
            <div>
                {#each data as pagare (pagare.id)}
                    {#if isFiltered({group: pagare})}
                        {#if pagare.title}
                            <div class="primary mb-1 border-bottom pb-ii">{pagare.title}</div>
                        {:else}
                            <div class="my-15">
                                <hr class="my-0">
                            </div>
                        {/if}
                        {#each pagare.payments as payment}
                            {#if isFiltered({payment: payment})}
                                <div class="mb-1">
                                    <PagoAppCard bind:this={payment.ref}
                                                 bind:filtered={filtered}
                                                 bind:data="{payment.cuotas}"
                                                 bind:reciboUrl={reciboUrl}
                                                 bind:cuotaOrden={cuotasOrden[payment.id]}
                                                 detalles="{payment.detalles}"
                                                 on:selected={(ev) => {updatedChecks(ev.detail, true);}}/>
                                </div>
                            {/if}
                        {/each}
                    {/if}
                {/each}
            </div>
            <div>
                <div class="summary-wrapper min-w-300px">
                    <PagoAppSummary {reglas}
                                    bind:total={total}
                                    bind:data={endosos}
                                    on:formas={()=>openFormas=true}
                                    on:click={() => {createPayment()}}/>
                </div>
            </div>
        </div>
    </div>

    <Dialog bind:open>
        <Content>{ dialogMessage }</Content>
        <Actions>
            <NauiButton caption="Aceptar" color="accent" mode="solid" on:click={() => {open = false;}}/>
        </Actions>
    </Dialog>

</section>
<PagoAppBuscar bind:open={openSearch} on:apply={applyFilters} bind:filters/>
<PagosFormasDisponibles bind:open={openFormas}/>
<style>
    .summary-wrapper {
        position: sticky;
        top: calc(60px + 1rem);
    }
</style>